let navigateFn;

export const setGlobalNavigate = (nav) => {
	navigateFn = nav;
};

export const globalNavigate = (url, options = { external: false }) => {
	if (options.external) {
		window.location.href = url; // Full reload
	} else if (navigateFn) {
		navigateFn(url); // SPA navigation
	} else {
		console.warn("globalNavigate called before being set.");
	}
};